import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getServerRoleNum, gmCountry } from "@/api/gmtool/packageCode";
import { serchSelect } from "@/mixins/index";
import { gmTool } from "@/mixins/index";
export default {
  name: "rolesCreated",
  mixins: [gmTool, serchSelect],
  data: function data() {
    return {
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      paramsData: {
        start_time: '',
        end_time: '',
        country: '',
        server_id: []
      },
      date: [],
      countryList: [],
      countryShow: false,
      total: 0
    };
  },
  created: function created() {
    this.Renewal();
    this.getCountry();
    this.getsearchDate();
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.reqLoading = true;
                _this.currentPage = 1;
                _this.paramsData.start_time = _this.date ? _this.date[0] : '';
                _this.paramsData.end_time = _this.date ? _this.date[1] : '';
                getServerRoleNum(_objectSpread(_objectSpread({}, _this.searchData), _this.paramsData)).then(function (res) {
                  if (res.status == 200) {
                    _this.countryShow = _this.paramsData.country.length ? true : false; // this.tableCopyTableList = JSON.parse(JSON.stringify(res.data))
                    // this.tableData = this.currentChangePage(this.pageSize, this.currentPage)

                    _this.tableData = res.data;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.date[0] = date;
      this.date[1] = date;
    },
    Renewal: function Renewal() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.paramsData.server_id = [];
                _context3.next = 3;
                return _this2.getserverList();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getCountry: function getCountry() {
      var _this3 = this;

      gmCountry(this.paramsData).then(function (res) {
        if (res.status == 200) {
          var arr = [];
          res.data.forEach(function (i) {
            arr.push({
              label: i,
              value: i
            });
          });
          _this3.countryList = arr;
        }
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        value: 'date'
      }, {
        label: this.$t('serverId'),
        value: 'server_id'
      }, {
        label: this.$t('roleCount'),
        value: 'total'
      }, {
        label: this.$t('payRoleCount'),
        value: 'payServerNum'
      }];
      this.$export.excel({
        columns: columns,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};